
export default {
  name: 'AppStatusBox',
  computed: {
    appStatusMessages() {
      return this.$store.getters['store__app/getAppStatusMessages']
    }
  }
}
